import { Outlet } from 'react-router-dom';

export const FeatureTestRoutes = () => {
  const energimerkeV2025Enabled = window.config.VITE_ENERGIMERKE_V2025_ENABLED;

  if (!energimerkeV2025Enabled) {
    return null;
  }
  return (
    <div style={{ width: '740px', margin: '3rem auto' }}>
      <Outlet />
    </div>
  );
};
